import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-stocks/new/loading';

export const Route = createFileRoute('/_private/settings/inventory-stocks/new')({
  component: Loading,
});
